import { NavbarBorrowSystem } from "../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
// import { BorrowFollowSixComponent } from "../../components/borrowSystem/BorrowFollowSixComponent";
import { CheckBorrowSixComponent } from "../../components/borrowSystem/CheckBorrowSixComponent";
import { Footer } from "../../components/share/Footer";

export function CheckBorrowSixContainer() {
  const titleName =
    "ข้อมูลการติดตามประเมินผลการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานกรมพัฒนาฝีมือแรงงาน กระทรวงแรงงาน กย.6";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <CheckBorrowSixComponent/>
      <Footer />
    </div>
  );
}
